import React from 'react'
import Img from 'gatsby-image'

import Layout from 'components/Layout'
import SEO from 'components/SEO'
import styled from 'util/style'
import { Link } from 'components/Link'

const Meten = styled.div`
  max-width: 60%;
  line-height: 2em;
  margin: 0 auto;
  text-align: center;
`

const MeetUitleg = styled.div`
  > div {
    max-width: 60%;
    display: block;
    margin: 0 auto;

    @media (max-width: 640px) {
      max-width: 90%;
    }
  }
`

const Button = styled.div`
  background: #000;
  text-transform: uppercase;
  color: #fff;
  padding: 6px 20px;
  text-align: center;
  display: inline-block;
  font-weight: bold;
  font-size: 12px;
  margin: 0 auto 20px auto;
`

export function Meten_HeupPage({ data }) {

  return (
    <Layout>
      <SEO title="Uitleg meten van je heupen" />

        <Meten>
            <Link to="/broekenfilter">
              <Button>Ga terug</Button>
            </Link>

            <MeetUitleg>
                <Img fluid={data.meten01.childImageSharp.fluid} />
            </MeetUitleg>
        </Meten>
    </Layout>
  )
}


export const query = graphql`
  query meten02 {
    meten01: file(relativePath: { eq: "meten/uitleg01.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 600) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`

export default Meten_HeupPage
